import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
// import './MemberProfile.css';

const membersData = {
    'yassine-isbouia': {
        name: 'Yassine Isbouia',
        picture: 'images/members/yassine-isbouia.jpeg',
        title: 'Research Scientist',
        shortBio: 'AI Researcher specializing in Computer Vision and Deep Learning',
        biography: `Detailed biography paragraph here...`,
        education: [
            {
                degree: 'Ph.D. in Computer Science',
                institution: 'University Name',
                year: '2020-Present'
            },
            {
                degree: 'M.Sc. in Artificial Intelligence',
                institution: 'University Name',
                year: '2018-2020'
            }
        ],
        research: {
            interests: ['Computer Vision', 'Deep Learning', 'Pattern Recognition', 'Machine Learning'],
            publications: [
                {
                    title: 'Publication Title 1',
                    authors: 'Authors names',
                    journal: 'Journal Name',
                    year: '2023',
                    doi: 'DOI link'
                }
            ]
        },
        projects: [
            {
                title: 'Project Name 1',
                description: 'Brief project description',
                link: 'project-link'
            }
        ],
        social: {
            linkedin: 'linkedin-profile-url',
            github: 'github-profile-url',
            email: 'email@domain.com',
            twitter: 'twitter-profile-url',
            researchgate: 'researchgate-profile-url'
        }
    },
    // Add other members' data similarly
};

function MemberProfile() {
    const { memberId } = useParams();
    const member = membersData[memberId];

    if (!member) {
        return <Navigate to="/members" replace />;
    }

    return (
        <div className="member-profile">
            {/* Hero Section */}
            <div className="profile-hero">
                <div className="profile-header">
                    <img src={`/${member.picture}`} alt={member.name} className="profile-picture" />
                    <div className="profile-header-content">
                        <h1>{member.name}</h1>
                        <h2>{member.title}</h2>
                        <p className="short-bio">{member.shortBio}</p>
                        <div className="social-links">
                            {member.social.linkedin && (
                                <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                                    <FaLinkedin />
                                </a>
                            )}
                            {member.social.github && (
                                <a href={member.social.github} target="_blank" rel="noopener noreferrer">
                                    <FaGithub />
                                </a>
                            )}
                            {member.social.email && (
                                <a href={`mailto:${member.social.email}`}>
                                    <FaEnvelope />
                                </a>
                            )}
                            {/* Add other social links similarly */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="profile-content">
                {/* Biography Section */}
                <section className="profile-section">
                    <h2>Biography</h2>
                    <p>{member.biography}</p>
                </section>

                {/* Education Section */}
                <section className="profile-section">
                    <h2>Education</h2>
                    <div className="education-list">
                        {member.education.map((edu, index) => (
                            <div key={index} className="education-item">
                                <h3>{edu.degree}</h3>
                                <p>{edu.institution}</p>
                                <p className="year">{edu.year}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Research Interests */}
                <section className="profile-section">
                    <h2>Research Interests</h2>
                    <div className="interests-list">
                        {member.research.interests.map((interest, index) => (
                            <span key={index} className="interest-tag">
                                {interest}
                            </span>
                        ))}
                    </div>
                </section>

                {/* Publications */}
                <section className="profile-section">
                    <h2>Publications</h2>
                    <div className="publications-list">
                        {member.research.publications.map((pub, index) => (
                            <div key={index} className="publication-item">
                                <h3>{pub.title}</h3>
                                <p>{pub.authors}</p>
                                <p>{pub.journal}, {pub.year}</p>
                                <a href={pub.doi} target="_blank" rel="noopener noreferrer">
                                    View Publication
                                </a>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Projects */}
                <section className="profile-section">
                    <h2>Projects</h2>
                    <div className="projects-list">
                        {member.projects.map((project, index) => (
                            <div key={index} className="project-item">
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>
                                <a href={project.link} target="_blank" rel="noopener noreferrer">
                                    Learn More
                                </a>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
}

export default MemberProfile; 